import { SxProps } from '@mui/material';

export const BenefitsDistFrameSX: SxProps = {
	background: '#FAFCFF',
	marginTop: { sm: 'var(--spacing-8)' },
};

export const BenefitsDistContainerItemSX = (isTablet: boolean) =>
	({
		width: '100%',
		marginTop: isTablet ? '40px' : '18px',
		mb: '40px',
	} as SxProps);

export const BenefitsDistTitleSX: SxProps = {
	textAlign: 'center',
	marginTop: 'var(--spacing-8)',
};
